import React, { useEffect, useState } from 'react'
import Choice from './Choice';
import FileInput from './FileInput';
import WYSIWYG from './WYSIWYG';
import { MilestoneStep, Milestone, GigStepPropertyWithValue, GigStepProperty, MilestonSpecifications, CTA } from 'types/collaboration';
import CaptionInput from '../components/CaptionInput';

interface FormFieldsProps {
    step: MilestoneStep
    activeMilestone: Milestone,
    onChange: (updatedProperties: GigStepPropertyWithValue[]) => void,
    largeFilesUploadProgress?: { [key: string]: number }
}

const FormFields: React.FC<FormFieldsProps> = ({ step, activeMilestone, onChange, largeFilesUploadProgress }) => {

    const [properties, setProperties] = useState<GigStepPropertyWithValue[]>([]);

    useEffect(() => {
        let _properties = Array.isArray(step?.gig_step?.properties) ? [...step.gig_step.properties] : [];

        _properties = _properties.sort((a, b) => a.sort_order - b.sort_order);

        setProperties(_properties);
    }, [step])

    useEffect(() => {
        onChange(properties);
    },[properties])

    useEffect(() => {
        if (largeFilesUploadProgress) {
            setProperties((prev) => {
                return prev.map((property) => {
                    if (['file', 'large_file'].includes(property.type) && largeFilesUploadProgress.hasOwnProperty(property.key)) {
                        return { ...property, progress: largeFilesUploadProgress[property.key] }
                    }
                    return property;
                })
            })
        }
    }, [largeFilesUploadProgress])

    const getChoiceOptions = (property: GigStepProperty) => {
        let options: string[] = [];
        if (property.choices?.property && activeMilestone) {
            const properties = property.choices.property.split(".");
            if (properties.length > 0) {
                switch (properties[0]) {
                    case "milestone_specifications":
                        {
                            if (activeMilestone.specifications.hasOwnProperty(properties[1]) && activeMilestone.specifications[properties[1] as keyof MilestonSpecifications]) {
                                options = activeMilestone.specifications[properties[1] as keyof MilestonSpecifications] as string[];
                            }
                            break;
                        }
                }
            }
        }

        return options;
    }

    const handleChange = (index: number, value: string | boolean | File | CTA ) => {
        let updated_properties = [...properties];
        updated_properties[index] = { ...updated_properties[index], value };
        setProperties(updated_properties);
    }

    const getAcceptedFileTypes = (property: GigStepProperty) => {
        let accepted: any = {};

        if (Array.isArray(property.attributes.accepted)) {
            for (let acceptedFileType of property.attributes.accepted) {
                accepted[acceptedFileType] = []
            }
        }

        return accepted;
    }

    return (
        <React.Fragment>
            {
                properties?.map((property, i) => {
                    return (
                        <div key={i} className='form-builder-field'>
                            {
                                !['boolean', 'choice', 'wysiwyg', 'approval'].includes(property.type) &&
                                <label className='form-builder-label' htmlFor={`form-field-${i}`}>{property.label} {property.mandatory && <span className="text-danger">*</span>}</label>
                            }
                            {
                                property.type === 'choice' &&
                                <Choice options={getChoiceOptions(property)} selected={property.value} onChange={(value) => handleChange(i, value)} />
                            }
                            {
                                property.type === 'text' &&
                                <input type='text' className='form-control form-builder-input' value={typeof property.value === 'string' ? property.value : ''} onChange={(e) => handleChange(i, e.target.value)} />
                            }
                            {
                                 property.type === 'textarea' &&
                                <textarea rows={4} className='form-control form-builder-textarea' value={typeof property.value === 'string' ? property.value : ''} onChange={(e) => handleChange(i, e.target.value)}> </textarea>
                            }
                            {
                                property.type === 'caption' &&
                                <CaptionInput value={typeof property.value === 'string' ? property.value : ''} onChange={(text) => handleChange(i, text)} hashtags={activeMilestone?.specifications?.hashtags ?? []} mentions={activeMilestone?.specifications?.mentions ?? []} />
                            }
                            {
                                property.type === 'number' &&
                                <input type='number' className='form-control form-builder-input' value={typeof property.value === 'string' ? property.value : ''} onChange={(e) => handleChange(i, e.target.value)} />
                            }
                            {
                                property.type === 'date' &&
                                <input type='date' className='form-control form-builder-input' value={typeof property.value === 'string' ? property.value : ''} onChange={(e) => handleChange(i, e.target.value)} />
                            }
                            {
                                property.type === 'datetime' &&
                                <input type='datetime-local' className='form-control form-builder-input' value={typeof property.value === 'string' ? property.value : ''} onChange={(e) => handleChange(i, e.target.value)} />
                            }
                            {
                                ['file', 'large_file'].includes(property.type) &&
                                <FileInput onChange={(file) => handleChange(i, file)} accept={getAcceptedFileTypes(property)} maxSize={property.attributes.max_file_size} minSize={property.attributes.min_file_size} progress={property.progress} />
                            }
                            {
                                property.type === 'wysiwyg' &&
                                <React.Fragment>
                                    <label className='form-builder-label' htmlFor={`form-field-${i}`}> Add script for reel, post, story {property.mandatory && <span className="text-danger">*</span>}</label>
                                    <WYSIWYG defaultValue={typeof property.value === 'string' ? property.value : ''} onChange={(val) => handleChange(i, val)} />
                                </React.Fragment>
                            }
                            {
                                property.error &&
                                <span className="text-danger">{property.error}</span>
                            }
                        </div>
                    )
                })
            }
        </React.Fragment>
    )
}

export default FormFields